import { Alert, CircularProgress, Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

import { InternetRegistrationEntry } from "./components/review-entry/InternetRegistrationEntry";
import { useInternetRegistrationMutations } from "./hooks/useInternetRegistrationMutations";
import { useInternetRegistrationsQuery } from "./hooks/useInternetRegistrationsQuery";

export function InternetRegistration() {
  const { t } = useTranslation();
  const { data: entries, isLoading, isError } = useInternetRegistrationsQuery();
  const { dismissDuplicate, decidingClientIds } = useInternetRegistrationMutations();

  return (
    <Stack spacing={2} pb={3}>
      <Typography variant="h1">{t("internetRegistrations.title")}</Typography>

      {isLoading && (
        <Stack alignItems="center" py={4}>
          <CircularProgress aria-label={t("internetRegistrations.loading")} />
        </Stack>
      )}

      {isError && <Alert severity="error">{t("internetRegistrations.loadFailed")}</Alert>}

      {/* Only an actually empty list may say the queue is empty — a failed load renders the alert above. */}
      {!isLoading && !isError && entries?.length === 0 && (
        <Typography color="text.secondary">{t("internetRegistrations.empty")}</Typography>
      )}

      <Stack spacing={2}>
        {entries?.map((entry) => (
          <InternetRegistrationEntry
            key={entry.newRegistration.clientId}
            entry={entry}
            // Only the entries actually being decided lock; the others stay usable.
            isDeciding={decidingClientIds.includes(entry.newRegistration.clientId)}
            onNotADuplicate={dismissDuplicate.mutate}
          />
        ))}
      </Stack>
    </Stack>
  );
}
